import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/76'

const AverageCheckByHandoffModeTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="revenue.tabs.average_check_by_handoff_mode"
  />
)

export default AverageCheckByHandoffModeTab
